export var SimID;
(function (SimID) {
    function equals(a, b) {
        return a.id === b.id && a.operator === b.operator;
    }
    SimID.equals = equals;
})(SimID || (SimID = {}));
export var Operator;
(function (Operator) {
    Operator["mts"] = "mts";
    Operator["mts_zo"] = "mts_zo";
    Operator["mts_nn"] = "mts_nn";
    Operator["beeline"] = "beeline";
    Operator["megafon"] = "megafon";
    Operator["beeline_jasper"] = "beeline_jasper";
})(Operator || (Operator = {}));
export var BilledSimTariff;
(function (BilledSimTariff) {
    BilledSimTariff["BASE"] = "base";
    BilledSimTariff["BIG"] = "big";
    BilledSimTariff["UNLIMITED"] = "unlimited";
})(BilledSimTariff || (BilledSimTariff = {}));
